import { object, string } from 'yup';

export const employmentSchema = object({
  companyId: string(),
  description: string().nullable(),
});
